import React, {useEffect, useState} from "react";
import CCNLProprietaEditor from "./formProprietaCCNL";
import CCNLLivelloPage from "./CCNLLivello.page";
import {CreateButton, useEditor} from "../../../core/editor";
import {CCNLRecord} from "@commons/mapping/SettoriCCNL";
import {useQueryFilter} from "../../../components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";

import {Tab} from "@headlessui/react";
import DTTitle from "../../../components/dataTable/TableTitle";
import DTTable from "../../../components/dataTable/Table";
import * as Buttons from "../../../components/dataTable/buttons";
import Pagination from "../../../components/dataTable/Pagination";
import {
    TabellaCCNL,
    useDeleteCCNLMutation,
    useGetTabellaCCNLQuery,
    useInsertElementoMutation,
    useLazyGetSingoloCCNLQuery,
    useUpdateElementoMutation
} from "@commons/features/sistema/ULTabellaCCNL.api";
import {useFactory} from "@commons/utils/useFactory";
import {TabellaSpool} from "@commons/features/varie/spool.api";

const CCNLPage: React.FC<{}> = () => {
    const [tabIndex, setTabIndex] = useState<number>(0);

    const [update, setUpdate] = useState<boolean>(false)

    const {resource, create, cancel, URI, loadResource, saveResource, deleteResource, editorState,} = useEditor<CCNLRecord>(
        useInsertElementoMutation()[0],
        useLazyGetSingoloCCNLQuery()[0],
        useUpdateElementoMutation()[0],
        useDeleteCCNLMutation()[0],
    );

    const pagination = usePagination('',1, 10);


    const {filter, setFilter, skip} = useQueryFilter<TabellaCCNL>({
        nowId: (new Date()).getTime()
    } as TabellaSpool, pagination);

    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;

    const {data} = useGetTabellaCCNLQuery(filter, {skip: skip, refetchOnMountOrArgChange: true});

    const defaultValues = useFactory(CCNLRecord.factory, {}); // N.B. useFactory utilizza useMemo!
    // const defaultValues = {tipologiaCCNL: 'NUOVO', numMensilita: 13} as CCNLRecord; //--> inseriti nella factory

    useEffect(() => {
            setFilter(filter => ({
                ...filter, nowId: (new Date()).getTime(),
            }));
    }, [setFilter])

    useEffect(() => {
        setFilter(filter => ({
            ...filter, nowId: (new Date()).getTime(),
        }));
        setUpdate(false)
    }, [update, setFilter])

    return <>
        <div className="px-2 py-3 bg-gray-200 rounded-lg">
            <div className="m-2">
                <div className="relative">
                    {tabIndex === 0 && <div className="absolute right-2">
                        <CreateButton<CCNLRecord> create={create} label="CCNL"/>
                    </div>}
                </div>

                <Tab.Group selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
                    <Tab.List className="tab-list">
                        <Tab className="tab">Propriet&agrave;</Tab>
                        <Tab disabled={URI === null} className="tab">Livelli</Tab>
                    </Tab.List>

                    <Tab.Panels className="tab-panels">
                        <Tab.Panel unmount={false}> {/* unmount permette di NON distruggere il tab ogni volta che si cambia tab!!! */}
                            {resource && <div className="p-3">
                                <CCNLProprietaEditor defaultValues={defaultValues} resource={resource} onSubmit={saveResource} onCancel={cancel}></CCNLProprietaEditor>
                            </div>}
                        </Tab.Panel>
                        <Tab.Panel unmount={false} className="p-3">
                            {resource && (URI || editorState === 'update') && <div className="p-3">
                                <CCNLLivelloPage codContratto={resource.codContratto} codContrattoUNILAV={resource.codContrattoUNILAV}></CCNLLivelloPage>
                            </div>}
                        </Tab.Panel>

                    </Tab.Panels>
                </Tab.Group>
            </div>
        </div>

        <DTTitle id="elencoCCNL" title="Elenco CCNL" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

        <DTTable<CCNLRecord> dtSchema={data}
                             header={<>
                                 <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                     Cod. UNILAV
                                 </th>
                                 <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                     Cod. INPS
                                 </th>
                                 <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                     Settore
                                 </th>
                                 <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[600px]">
                                     Descrizione
                                 </th>
                                 <th scope="col" className="py-3.5 w-14"/>
                             </>}

                             rows={({item, index, isMobile, currentRow, register}) => (
                                 <tr {...register(item.codContrattoUNILAV + '_' + item.codContratto!, index, item.URI === URI)}>
                                     <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                         {item.codContrattoUNILAV}
                                     </td>
                                     <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                         {item.codContratto}
                                     </td>
                                     <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                         {item.settore}
                                     </td>
                                     <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 min-w-[600px]">
                                         {item.descrizione}
                                     </td>
                                     <td className="align-middle text-sm font-medium">
                                         <Buttons.Visibility visible={isMobile || index === currentRow}>
                                             <Buttons.Edit onAction={() => loadResource(item.URI)}/>
                                             <Buttons.Delete onConfirm={() => {
                                                 deleteResource(item.URI!)
                                                 setUpdate(true);
                                             }}/>
                                         </Buttons.Visibility>
                                     </td>
                                 </tr>)
                             }
        />

        <Pagination dataTables={data} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>
    </>
}

export default CCNLPage;
